module.exports = __webpack_public_path__ + "static/media/sagemaker-notebook-icon.16b8ce34.svg";